import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { createElement, Component } from 'react';
import '../../utils/windowEvents/ScrollEvents.js';
import { getInitialViewportSize, addViewportCallback, removeViewportCallback } from '../../utils/windowEvents/ResizeEvents.js';
import { EyeCatcherPresentation } from './EyeCatcherPresentation.js';

var EyeCatcherWrapper = /*#__PURE__*/function (_Component) {
  _inherits(EyeCatcherWrapper, _Component);

  var _super = _createSuper(EyeCatcherWrapper);

  function EyeCatcherWrapper(props) {
    var _this;

    _classCallCheck(this, EyeCatcherWrapper);

    _this = _super.call(this, props);

    _this.viewportHandler = function (viewport) {
      _this.setState({
        viewport: viewport
      });
    };

    _this.state = {
      viewport: getInitialViewportSize()
    };
    return _this;
  }

  _createClass(EyeCatcherWrapper, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      addViewportCallback(this.viewportHandler);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      removeViewportCallback(this.viewportHandler);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/createElement(EyeCatcherPresentation, Object.assign({}, this.props, {
        viewport: this.state.viewport
      }));
    }
  }]);

  return EyeCatcherWrapper;
}(Component);

export { EyeCatcherWrapper };
